import request from './request';

//登录
function loginFunc(ticket, redirect) {
    return request({
        url: '/sys/login/',
        method: 'get',
        params: {
            ticket,
            redirect
        }
    })
}

//获取菜单
function getMenuOfPersonal() {
    return request({
        url: '/sys/get_personal_menu',
        method: 'get',
    })
}

//切换 企业
function switchEnterprise(co_id) {
    return request({
        url: 'sys/comp/switch/',
        method: 'put',
        data: {
            co_id
        }
    })
}

//获取企业列表
function getEnterprise(include_indiv_org) {
    return request({
        url: 'sys/comp/switch/',
        method: 'get',
        params: {
            include_indiv_org
        }
    })
}

//获取更新日志
function getUpdateLogList() {
    return request({
        url: '/sys/log/updates',
        method: 'get',
    })
}

//退出
function logoutFunc(redirect) {
    return request({
        url: '/sys/logout/',
        method: 'post',
        data: {
            redirect
        }
    })
}

//获取用户信息
function getUserInfo() {
    return request({
        url: '/sys/user/info/',
        method: 'get',
    })
}

//获取用户信息
function getMenus(
    co_id
) {
    return request({
        url: '/sys/user/menu/',
        method: 'get',
        params: {
            co_id
        }
    })
}

//获取个人设置菜单
function getPersonalMenus() {
    return request({
        url: '/sys/menu/personal/',
        method: 'get',

    })
}

//更改企业名称
function editCompName(data) {
    return request({
        url: '/sys/comp/name',
        method: 'put',
        data,
    })
}

/* ============================= 通知 ============================= */
//获取全部通知
function getNotices(page, page_size) {
    return request({
        url: `/sys/get_notice_list`,
        method: 'get',
        params: {
            page,
            page_size
        }
    })
}

//获取未读通知
function getUnreadNotices(page, page_size) {
    return request({
        url: `/sys/get_unread_notice`,
        method: 'get',
        params: {
            page,
            page_size
        }
    })
}

//消息修改已读状态接口
function setReadNotices() {
    return request({
        url: `/sys/put_notice_flag?spread=all`,
        method: 'put',
    })
}

//删除系统消息
function deleteNotices() {
    return request({
        url: `/sys/delete_notice?spread=read`,
        method: 'delete',
    })
}

/* ============================= 订阅方案 ============================= */
//获取订阅方案
function getPlanList(params) {
    return request({
        url: `/plan/list`,
        method: 'get',
        params: params
    })
}

//获取订阅方案及其历史
function getHistoryPlanList(subs_plan_id) {
    return request({
        url: `/plan/history`,
        method: 'get',
        params: {
            subs_plan_id
        }
    })
}
//添加订阅方案
function addPlanList(data) {
    return request({
        url: `/plan/add`,
        method: 'post',
        data
    })
}

//修改订阅方案
function updatePlanList(data) {
    return request({
        url: `/plan/update`,
        method: 'post',
        data
    })
}

//获取产品列表
function getProductList(prd_type_code) {
    return request({
        url: `/product/list${prd_type_code ? ('?prd_type_code=' + prd_type_code) : ''}`,
        method: 'get',
    })
}

//获取许可项列表
function getLicenseItemsList(co_id) {
    return request({
        url: `/sys/item/list`,
        method: 'get',
        params: {
            co_id
        }
    })
}

//获取产品模版列表
function getTemplateList(prd_code) {
    return request({
        url: `/sys/template/list`,
        method: 'get',
        params: {
            prd_code
        }
    })
}

//获取产品版本类型
function getVerType(version_type) {
    return request({
        url: `/sys/get_ver_type`,
        method: 'get',
        params: {
            version_type
        }
    })
}

//更新订阅方案状态
function changePlanStatus(subs_plan_id, status_code) {
    return request({
        url: `/plan/change`,
        method: 'put',
        data: {
            subs_plan_id,
            status_code
        }
    })
}

//批量更新订阅方案状态
function batchChangePlanStatus(data) {
    return request({
        url: `/plan/batch_update`,
        method: 'post',
        data
    })
}

/* ============================= 企业订阅 ============================= */
//获取订阅方案
function getEnterpriseList(params) {
    return request({
        url: `/enterprise/list`,
        method: 'get',
        params: params
    })
}

//获取企业列表
function getCompanyList(params) {
    return request({
        url: `/sys/enterprise/list`,
        method: 'get',
        params
    })
}

//新增企业订阅方案
function addEnterprise(data) {
    return request({
        url: `/enterprise/add`,
        method: 'post',
        data
    })
}

//获取企业历史订阅方案列表
function getHistoryEnterprise(data) {
    return request({
        url: `/enterprise/history`,
        method: 'get',
        params: data
    })
}

//撤销订阅
function unSubscribe(co_subs_id, co_id, subs_plan_id) {
    return request({
        url: `/enterprise/cancel`,
        method: 'post',
        data: {
            co_subs_id,
            co_id,
            subs_plan_id
        }
    })
}

//获取用户列表
function getUserList(user_name) {
    return request({
        url: `/cons/list`,
        method: 'get',
        params: {
            user_name
        }
    })
}

//创建正式企业
function createFormalEnterprise(user_id, company_name) {
    return request({
        url: `/sys/comp/create`,
        method: 'post',
        data: {
            user_id,
            company_name
        }
    })
}

//删除正式企业
function deleteEnterprise(co_id) {
    return request({
        url: `/sys/comp/delete`,
        method: 'delete',
        data: {
            co_id,
        }
    })
}

/* ============================= 企业管理 ============================= */
//获取企业列表
function getCompList(params) {
    return request({
        url: `/sys/comp/list`,
        method: 'get',
        params: params
    })
}

//获取企业角色
function getCoRole() {
    return request({
        url: `/sys/comp/get_co_role/`,
        method: 'get',
    })
}

//获取企业用户列表
function getCompanyUserList(co_id) {
    return request({
        url: `/sys/comp/get_company_user/?co_id=${co_id}`,
        method: 'get',
    })
}

//创建企业
function createCompany(data) {
    return request({
        url: `/sys/comp/create`,
        method: 'post',
        data
    })
}

//更新企业信息
function updateCompany(data) {
    return request({
        url: `/sys/comp/info`,
        method: 'put',
        data
    })
}

//批量添加企业成员
function bindCompanyUsers(data) {
    return request({
        url: `/sys/comp/user/import/`,
        method: 'post',
        data
    })
}

//更新企业状态
function changeCompanyStatus(data) {
    return request({
        url: `/sys/comp/status`,
        method: 'put',
        data
    })
}

/* ============================= 许可 ============================= */
//获取产品许可列表
function getLicenseList(params) {
    return request({
        url: `/license/list`,
        method: 'get',
        params: params
    })
}

//产品许可申请
function addLicense(data) {
    return request({
        url: `/license/add`,
        method: 'post',
        data
    })
}

//下载许可
function downLoadLicenseFile(id) {
    return request({
        url: `/license/download?license_id=${id}`,
        method: 'get',
        responseType: 'arraybuffer',
    })
}


/* ============================= TOC订阅 ============================= */
// 新增个人订阅
function addTocPersonalSubscription(data) {
    return request({
        url: '/toc_subs/personal/add',
        method: 'post',
        data
    });
}

// 续订个人订阅
function renewTocPersonalSubscription(data) {
    return request({
        url: '/toc_subs/personal/renew',
        method: 'post',
        data
    });
}

// 撤销个人订阅
function cancelTocPersonalSubscription(data) {
    return request({
        url: '/toc_subs/personal/cancel',
        method: 'post',
        data
    });
}

// 查看个人订阅详情
function getTocPersonalSubscriptionDetail(params) {
    return request({
        url: '/toc_subs/personal/detail',
        method: 'get',
        params
    });
}

// 个人订阅列表
function getTocPersonalSubscriptionList(params) {
    return request({
        url: '/toc_subs/personal/list',
        method: 'get',
        params
    });
}

// 新增企业订阅
function addTocEnterpriseSubscription(data) {
    return request({
        url: '/toc_subs/enterprise/add',
        method: 'post',
        data
    });
}

// 续订企业订阅
function renewTocEnterpriseSubscription(data) {
    return request({
        url: '/toc_subs/enterprise/renew',
        method: 'post',
        data
    });
}

// 撤销企业订阅
function cancelTocEnterpriseSubscription(data) {
    return request({
        url: '/toc_subs/enterprise/cancel',
        method: 'post',
        data
    });
}

// 查看企业订阅详情
function getTocEnterpriseSubscriptionDetail(params) {
    return request({
        url: '/toc_subs/enterprise/detail',
        method: 'get',
        params
    });
}

// 企业订阅列表
function getTocEnterpriseSubscriptionList(params) {
    return request({
        url: '/toc_subs/enterprise/list',
        method: 'get',
        params
    });
}

// TOC订阅方案列表
function getTocSubscriptionPlanList(params) {
    return request({
        url: '/plan/list',
        method: 'get',
        params
    });
}

// 获取TOC订阅历史 - DEPRECATED or mapped to detail
// Since the UI uses this separately in EditHtml, but the data comes from Detail API.
// We'll remove this and update the UI to use getTocPersonalSubscriptionDetail/getTocEnterpriseSubscriptionDetail.

/* ============================= Topup Management ============================= */

// 获取充值订单列表
function getTopupOrderList(params) {
    return request({
        url: '/topup/order/list',
        method: 'get',
        params
    });
}

// 查看充值订单详情
function getTopupOrderDetail(params) {
    return request({
        url: '/topup/order/detail',
        method: 'get',
        params
    });
}

// 取消充值订单
function cancelTopupOrder(data) {
    return request({
        url: '/topup/order/cancel',
        method: 'post',
        data
    });
}

// 下载充值订单列表
function downloadTopupOrderList(params) {
    return request({
        url: '/topup/order/download',
        method: 'get',
        params,
        responseType: 'blob'
    });
}

// 手工充值
function manualTopup(data) {
    return request({
        url: '/topup/order/manual',
        method: 'post',
        data
    });
}

/* ============================= Equity Record ============================= */

// 获取权益记录列表
function getEquityRecordList(params) {
    return request({
        url: '/topup/equity/list',
        method: 'get',
        params
    });
}

// 下载权益记录列表
function downloadEquityRecordList(params) {
    return request({
        url: '/topup/equity/download',
        method: 'get',
        params,
        responseType: 'blob'
    });
}

// 新增权益记录
function addEquityRecord(data) {
    return request({
        url: '/topup/equity/add',
        method: 'post',
        data
    });
}

/* ============================= Topup Plan (for manual topup) ============================= */

// 获取充值方案列表（已上架的）
function getAvailableTopupPlanList(params) {
    return request({
        url: '/topup/plan/list',
        method: 'get',
        params
    });
}

/* ============================= Enterprise/User Search (for manual topup) ============================= */

// 获取企业列表（用于企业充值）
function getCompanyListForTopup(params) {
    return request({
        url: 'sys/enterprise/list', // 复用现有接口
        method: 'get',
        params
    })
}

// 获取用户列表（用于个人充值）
function getUserListForTopup(params) {
    return request({
        url: '/sys/person/search', 
        method: 'get',
        params: {
            phone: params.user_name || params.phone
        }
    })
}

// TOC Search User by Phone
function searchUserByPhone(params) {
    return request({
        url: '/toc_subs/user/search_by_phone',
        method: 'get',
        params
    });
}

// TOC Get User Companies
function getUserCompanies(params) {
    return request({
        url: '/toc_subs/user/companies/simple',
        method: 'get',
        params
    });
}

/* ============================= Topup Plan Management ============================= */

// 获取充值方案列表
function getTopupPlanList(params) {
    return request({
        url: 'topup/plan/list',
        method: 'get',
        params
    })
}

// 获取充值方案详情
function getTopupPlanDetail(params) {
    return request({
        url: 'topup/plan/detail',
        method: 'get',
        params
    })
}

// 新增充值方案
function addTopupPlan(data) {
    return request({
        url: 'topup/plan/add',
        method: 'post',
        data
    })
}

// 更新充值方案
function updateTopupPlan(data) {
    return request({
        url: 'topup/plan/update',
        method: 'post',
        data
    })
}

// 删除充值方案
function deleteTopupPlan(data) {
    return request({
        url: 'topup/plan/delete',
        method: 'post',
        data
    })
}

// 提交审核 (原 publishTopupPlan)
function submitTopupPlanAudit(data) {
    return request({
        url: 'topup/plan/publish',
        method: 'post',
        data
    })
}

// 上架/下架充值方案
function toggleTopupPlanListing(data) {
    return request({
        url: 'topup/plan/list_action',
        method: 'post',
        data
    })
}

/* ============================= Topup Plan Audit ============================= */

// 获取审核列表
function getTopupAuditList(params) {
    return request({
        url: 'topup/plan/audit/list',
        method: 'get',
        params
    })
}

// 获取审核详情
function getTopupAuditDetail(params) {
    return request({
        url: 'topup/plan/audit/detail',
        method: 'get',
        params
    })
}

// 审核通过
function approveTopupAudit(data) {
    return request({
        url: 'topup/plan/audit',
        method: 'post',
        data: {
            ...data,
            audit_status_code: 'APPROVED'
        }
    })
}

// 审核驳回
function rejectTopupAudit(data) {
    return request({
        url: 'topup/plan/audit',
        method: 'post',
        data: {
            ...data,
            audit_status_code: 'REJECTED'
        }
    })
}

export default {
    searchUserByPhone,
    getUserCompanies,
    // Topup Management
    getTopupOrderList,
    getTopupOrderDetail,
    cancelTopupOrder,
    downloadTopupOrderList,
    manualTopup,
    // Equity Record
    getEquityRecordList,
    downloadEquityRecordList,
    addEquityRecord,
    // Topup Plan
    getAvailableTopupPlanList,
    getTopupPlanList,
    getTopupPlanDetail,
    addTopupPlan,
    updateTopupPlan,
    deleteTopupPlan,
    submitTopupPlanAudit,
    publishTopupPlan: submitTopupPlanAudit, // Alias for compatibility
    approveTopupAudit,
    rejectTopupAudit,
    toggleTopupPlanListing,
    getTopupAuditList,
    getTopupAuditDetail,
    // approveTopupAudit, // Removed as per API alignment
    // rejectTopupAudit, // Removed as per API alignment
    // Search
    getCompanyListForTopup,
    getUserListForTopup,
    getUserInfo,
    loginFunc,
    getMenus,
    logoutFunc,
    getPersonalMenus,
    getNotices,
    getUnreadNotices,
    setReadNotices,
    deleteNotices,
    getPlanList,
    getProductList,
    getTemplateList,
    getLicenseItemsList,
    getEnterpriseList,
    addPlanList,
    updatePlanList,
    changePlanStatus,
    getCompanyList,
    getVerType,
    addEnterprise,
    getHistoryEnterprise,
    getLicenseList,
    addLicense,
    getMenuOfPersonal,
    downLoadLicenseFile,
    getUpdateLogList,
    switchEnterprise,
    getEnterprise,
    unSubscribe,
    getUserList,
    createFormalEnterprise,
    getHistoryPlanList,
    getCompList,
    getCoRole,
    getCompanyUserList,
    createCompany,
    bindCompanyUsers,
    updateCompany,
    changeCompanyStatus,
    deleteEnterprise,
    editCompName,
    batchChangePlanStatus,
    // TOC个人订阅
    addTocPersonalSubscription,
    renewTocPersonalSubscription,
    cancelTocPersonalSubscription,
    getTocPersonalSubscriptionDetail,
    getTocPersonalSubscriptionList,
    // TOC企业订阅
    addTocEnterpriseSubscription,
    renewTocEnterpriseSubscription,
    cancelTocEnterpriseSubscription,
    getTocEnterpriseSubscriptionDetail,
    getTocEnterpriseSubscriptionList,
    // TOC订阅方案列表
    getTocSubscriptionPlanList,

    /* ============================= TOC Enterprise Management ============================= */
    // 获取企业子账号列表
    getTocEnterpriseSubAccounts(params) {
        return request({
            url: '/toc_subs/enterprise/sub_accounts',
            method: 'get',
            params
        });
    },
    // 同步企业子账号
    syncTocEnterpriseSubAccounts(data) {
        return request({
            url: '/toc_subs/enterprise/sub_accounts/sync',
            method: 'post',
            data
        });
    },
    // 移除企业成员
    removeTocEnterpriseMember(data) {
        return request({
            url: '/toc_subs/enterprise/members/remove',
            method: 'post',
            data
        });
    },
    // 退出企业
    quitTocEnterprise(data) {
        return request({
            url: '/toc_subs/enterprise/members/quit',
            method: 'post',
            data
        });
    },
    // 设置企业成员角色
    setTocEnterpriseMemberRole(data) {
        return request({
            url: '/toc_subs/enterprise/members/role',
            method: 'put',
            data
        });
    },
    // 移交所有者权限
    transferTocEnterpriseOwner(data) {
        return request({
            url: '/toc_subs/enterprise/members/transfer_owner',
            method: 'post',
            data
        });
    },
    // 修改企业名称
    updateTocEnterpriseName(data) {
        return request({
            url: '/toc_subs/enterprise/name',
            method: 'put',
            data
        });
    },
}
